import { z } from 'zod';

import { idSchema } from './utils';

export type DistributorUserPathParams = z.infer<typeof distributorUserPathParamsSchema>;
export const distributorUserPathParamsSchema = z.object({
  distributorId: idSchema('distributorId'),
  userId: idSchema('userId'),
});

export type AddDistributorUserBody = z.infer<typeof addDistributorUserBodySchema>;
export const addDistributorUserBodySchema = z.object({
  distributorId: idSchema('distributorId'),
  email: z.string(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  phoneNr: z.string().optional(),
});
